import React from 'react';
import { FileText } from 'lucide-react';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@roger/ui-components';

/**
 * Right-aligned Actions-cell button that opens the claim worksheet. Editable in
 * Pending Approval (`label='Edit claim worksheet'`); read-only once the cycle is
 * approved (`label='View claim worksheet'`).
 */
export const ClaimWorksheetActionButton: React.FC<{
  onClick: () => void;
  label: string;
}> = ({ onClick, label }) => (
  <TooltipProvider delayDuration={300}>
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type='button'
          variant='ghost'
          size='icon'
          onClick={onClick}
          className='text-muted-foreground hover:text-foreground'
          aria-label={label}
        >
          <FileText className='h-4 w-4' />
        </Button>
      </TooltipTrigger>
      <TooltipContent side='bottom' className='text-xs'>
        {label}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
